import { createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue"

import { computed } from 'vue'

import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import WizardConfirmModal from '@/components/neue/wizard/WizardConfirmModal.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { useConfirm } from '@/composables/useConfirm'
import { injectWizard } from '@/composables/useWizardContext'
import { sectionCopy, storeSettings } from '@/config/agentWizardSteps'

const ALREADY_SET_UP = 'Already set up'


export default {
  __name: 'AgentStoresSection',
  props: {
  stepKey: { type: String, required: true },
  subStep: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const wizard = injectWizard()
const section = computed(() => wizard.data[props.stepKey])

const isTicked = id => section.value.store_ids.includes(String(id))
const isCovered = id => wizard.existing.value[props.stepKey].has(String(id))

const toggle = id => {
  const key = String(id)
  section.value.store_ids = isTicked(key)
    ? section.value.store_ids.filter(candidate => candidate !== key)
    : [...section.value.store_ids, key]
}

// Every ticked store starts from the shared values; unticked stores get nothing.
const customise = () => {
  section.value.stores = Object.fromEntries(
    section.value.store_ids.map(id => [id, { ...storeSettings(wizard.data, props.stepKey, id) }])
  )
  section.value.per_store = true
  wizard.go(props.stepKey, section.value.store_ids[0] ?? null)
}

const { state: confirmState, ask, confirm: confirmYes, cancel: confirmNo } = useConfirm()

// The first store's values become the shared ones.
const useSameSettings = async () => {
  const sure = await ask({
    title: 'Use the same settings for every store?',
    message:
      'The first store settings are kept and applied to every ticked store. Other per store changes are dropped.',
    confirmLabel: 'Use the same settings'
  })
  if (!sure) return
  const first = section.value.store_ids[0]
  Object.assign(section.value, section.value.stores[first] ?? {}, { per_store: false, stores: {} })
  wizard.go(props.stepKey, null)
}

return (_ctx, _cache) => {
  return (__props.subStep)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", { class: "border-t border-gray-200 py-[26px]" }, [
          _createElementVNode("button", {
            type: "button",
            class: "text-sm text-gray-600 underline hover:text-gray-900",
            onClick: useSameSettings
          }, " Use the same settings for every store ")
        ]),
        _createVNode(WizardConfirmModal, _mergeProps(_unref(confirmState), {
          onConfirm: _unref(confirmYes),
          onCancel: _unref(confirmNo)
        }), null, 16, ["onConfirm", "onCancel"])
      ], 64))
    : (_unref(wizard).ctx.storeCount > 1)
      ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 1 }, _unref(sectionCopy)(`${__props.stepKey}.stores`, _unref(wizard).data, _unref(wizard).ctx))), {
          default: _withCtx(() => [
            (!section.value.per_store)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wizard).stores.value, (store) => {
                    return (_openBlock(), _createBlock(SelectionCard, {
                      key: store.id,
                      mode: "checkbox",
                      compact: "",
                      selected: isTicked(store.id),
                      disabled: isCovered(store.id),
                      title: store.store_name,
                      subtitle: store.storefront_url,
                      chip: isCovered(store.id) ? ALREADY_SET_UP : '',
                      onSelect: $event => (toggle(store.id))
                    }, null, 8, ["selected", "disabled", "title", "subtitle", "chip", "onSelect"]))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "self-start text-sm text-gray-600 underline hover:text-gray-900",
                    onClick: customise
                  }, " Customise per store ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("p", {
                    "data-per-store-note": "",
                    class: "m-0 rounded-md bg-gray-100 px-3 py-2 text-[13px] text-gray-600"
                  }, " Each ticked store has its own settings. Continue to set them up one by one. ", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "self-start text-sm text-gray-600 underline hover:text-gray-900",
                    onClick: useSameSettings
                  }, " Use the same settings for every store ")
                ], 64)),
            _createVNode(WizardConfirmModal, _mergeProps(_unref(confirmState), {
              onConfirm: _unref(confirmYes),
              onCancel: _unref(confirmNo)
            }), null, 16, ["onConfirm", "onCancel"])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
}
}

}